import { render } from "./OverlayScreen.vue?vue&type=template&id=5b237b48&scoped=true"
import script from "./OverlayScreen.vue?vue&type=script&lang=js"
export * from "./OverlayScreen.vue?vue&type=script&lang=js"

import "./OverlayScreen.vue?vue&type=style&index=0&id=5b237b48&lang=scss&scoped=true"

import exportComponent from "/home/tachyon/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b237b48"]])

export default __exports__